import { Box, Typography } from '@mui/material';
import { UpgradeBanner } from '../components/upgradeBanner';
import theme from '@shared/themes/darkTheme';
import { FreemiumPrices } from '../components/FreemiumPrices';

export const MarketsDashboard = () => {
  return (
    <Box sx={{ width: '100%', height: '100%', p: 2, display: 'flex', flexDirection: 'column' }}>
      <UpgradeBanner />
      <Box sx={{ width: '100%', display: 'flex', flexDirection: 'row', gap: 2, mb: 2 }}>
        <Box
          sx={{
            width: '50%',
            height: '500px',
            border: `1px solid ${theme.palette.background.darker}`,
            backgroundColor: theme.palette.background.default,
            p: 1,
            borderRadius: 1,
          }}
        >
          <Box sx={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'column' }}>
            <Typography sx={{ fontSize: 12, fontWeight: 600, mb: 1 }}>Chart</Typography>
          </Box>
        </Box>
        <Box
          sx={{
            width: '50%',
            height: '500px',
            border: `1px solid ${theme.palette.background.darker}`,
            backgroundColor: theme.palette.background.default,
            p: 1,
            borderRadius: 1,
            minHeight: '100px',
            maxHeight: '600px',
          }}
        >
          <Box sx={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'column', overflowX: 'hidden', overflowY: 'auto' }}>
            <Typography sx={{ fontSize: 12, fontWeight: 600, mb: 1 }}>Chart</Typography>
          </Box>
        </Box>
      </Box>
      <Box sx={{ width: '100%', display: 'flex', flexDirection: 'row', gap: 2 }}>
        <Box
          sx={{
            width: '50%',
            height: '500px',
            border: `1px solid ${theme.palette.background.darker}`,
            backgroundColor: theme.palette.background.default,
            p: 1,
            borderRadius: 1,
            minHeight: '100px',
            maxHeight: '600px',
          }}
        >
          <Box sx={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'column', overflowX: 'hidden', overflowY: 'auto' }}>
            <Typography sx={{ fontSize: 12, fontWeight: 600 }}>Delayed Prices</Typography>
            {<FreemiumPrices />}
          </Box>
        </Box>
        <Box sx={{ width: '50%', display: 'flex', flexDirection: 'row', gap: 2 }}>
          <Box sx={{ width: '100%', display: 'flex', flexDirection: 'column', gap: 2 }}>
            <Box
              sx={{
                width: '100%',
                height: '50%',
                border: `1px solid ${theme.palette.background.darker}`,
                backgroundColor: theme.palette.background.default,
                p: 1,
                borderRadius: 1,
                minHeight: '100px',
                maxHeight: '600px',
              }}
            >
              <Box sx={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'column', overflowX: 'hidden', overflowY: 'auto' }}>
                <Typography sx={{ fontSize: 12, fontWeight: 600, mb: 1 }}>Watch List</Typography>
              </Box>
            </Box>
            <Box
              sx={{
                width: '100%',
                height: '50%',
                border: `1px solid ${theme.palette.background.darker}`,
                backgroundColor: theme.palette.background.default,
                p: 1,
                borderRadius: 1,
                minHeight: '100px',
                maxHeight: '600px',
              }}
            >
              <Box sx={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'column', overflowX: 'hidden', overflowY: 'auto' }}>
                <Typography sx={{ fontSize: 12, fontWeight: 600, mb: 1 }}> Snapshots</Typography>
              </Box>
            </Box>
          </Box>
          <Box
            sx={{
              width: '100%',
              height: '500px',
              border: `1px solid ${theme.palette.background.darker}`,
              backgroundColor: theme.palette.background.default,
              p: 1,
              borderRadius: 1,
              minHeight: '100px',
              maxHeight: '600px',
            }}
          >
            <Box sx={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'column', overflowX: 'hidden', overflowY: 'auto' }}>
              <Typography sx={{ fontSize: 12, fontWeight: 600, mb: 1 }}>Headlines</Typography>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};
